<template>
  <form class="quick-order-form">
    <div class="quick-order-form__row">
      <div v-if="!isUserAuth" class="quick-order-form__col quick-order-form__col--full">
        <AuthPhone
          is-ajax-auth
          is-hidden-labels
          :touch-phone-flag="touchPhoneFlag"
          :remember-field="false"
          ref="authPhone"
        ></AuthPhone>
      </div>
      <div v-else class="quick-order-form__col">
        <PhoneInput v-model.trim="phone" id="phone-auth" :disable-fields="!isManager" />
      </div>
      <!-- пока /one-click/buy не принимает город -->
      <!-- <div v-if="isUserAuth && !isReserve" class="quick-order-form__col">
        <GeoSelectCity class="geo-select-city" type="select" />
      </div> -->
    </div>
    <div v-if="isUserAuth" class="quick-order-form__row">
      <div class="quick-order-form__col">
        <div class="control-box" :class="{ 'invalid dirty': $v.name.$error }">
          <Input
            class="quick-order-form__input"
            id="name"
            v-model.trim="name"
            @onBlur="$v.name.$touch"
            :placeholder="$t('subscribe.placeholder.name')"
          />
          <div class="quick-order-form__errors-wrap">
            <p class="control-box__help-block" :class="{ 'invalid dirty': $v.name.$error }" v-if="$v.name.$error">
              <template v-if="!$v.name.regCyr">
                {{ $t('field_contains_cyrillic') }}
                <br />
              </template>
              <template v-if="!$v.name.required">
                {{ $t('blank_field_error') }}
                <br />
              </template>
              <template v-if="!$v.name.minLength">
                {{ $t('notfull_field_error') }}
                <br />
              </template>
              <template v-if="!$v.name.regNum">
                {{ $t('field_contains_numbers') }}
                <br />
              </template>
              <template v-if="!$v.name.regSpace">
                {{ $t('field_contains_space') }}
                <br />
              </template>
              <template v-if="!$v.name.regSpec">
                {{ $t('field_contains_special_characters') }}
                <br />
              </template>
            </p>
          </div>
        </div>
      </div>
      <div class="quick-order-form__col">
        <div class="control-box" :class="{ 'invalid dirty': $v.lastName.$error }">
          <Input
            class="quick-order-form__input"
            id="lastName"
            v-model.trim="lastName"
            @onBlur="$v.lastName.$touch"
            :placeholder="$t('subscribe.placeholder.lastName')"
          />
          <div class="quick-order-form__errors-wrap">
            <p
              class="control-box__help-block"
              :class="{ 'invalid dirty': $v.lastName.$error }"
              v-if="$v.lastName.$error"
            >
              <template v-if="!$v.lastName.regCyr">
                {{ $t('field_contains_cyrillic') }}
                <br />
              </template>
              <template v-if="!$v.lastName.required">
                {{ $t('blank_field_error') }}
                <br />
              </template>
              <template v-if="!$v.lastName.minLength">
                {{ $t('notfull_field_error') }}
                <br />
              </template>
              <template v-if="!$v.lastName.regNum">
                {{ $t('field_contains_numbers') }}
                <br />
              </template>
              <template v-if="!$v.lastName.regSpace">
                {{ $t('field_contains_space') }}
                <br />
              </template>
              <template v-if="!$v.lastName.regSpec">
                {{ $t('field_contains_special_characters') }}
                <br />
              </template>
            </p>
          </div>
        </div>
      </div>
    </div>

    <slot name="form-footer" :submitHandler="handleSubmit" :isButtonDisabled="isFormLoading || $v.$invalid">
      <div class="quick-order-form__footer">
        <Button class="quick-order-modal__btn" @click.native="handleSubmit" :isDisabled="isFormLoading || $v.$invalid">
          {{ $t('to_order') }}
        </Button>
        <p class="agree-terms__text">
          {{ $t('agreement_text') }}
          <a :href="urlLanguagePrefix + '/terms-and-conditions/'" target="_blank" class="link agree-terms-link">
            {{ $t('agreement_link') }}
          </a>
        </p>
      </div>
    </slot>
    <Loader :is-loading="isFormLoading"></Loader>
  </form>
</template>

<script>
import { required, minLength } from 'vuelidate/lib/validators'
import AuthPhone from '@/components/auth/AuthPhone'
// import GeoSelectCity from '@/components/user-geo/GeoSelectCity'
import Input from '@/components/inputs/Input'
import PhoneInput from '@/components/inputs/PhoneInput'
import Loader from '@/components/helpers/Loader'
import Button from '@/components/inputs/Button'
import qs from 'qs'
import api from '@/api'
import { mapState, mapGetters } from 'vuex'
import { GoogleEnhancedEcommerce } from '@/services/AnalyticService'

const regCyr = value => !new RegExp(/[\u0400-\u04FF]/).test(value)
const regSpace = value => !new RegExp(/\s/g).test(value)
const regNum = value => !new RegExp(/\d/).test(value)
const regSpec = value => !new RegExp('[!@#№/$%^&*(),.?":;_=+{}|<>]').test(value)

export default {
  name: 'QuickOrderForm',
  components: {
    AuthPhone,
    // GeoSelectCity,
    Input,
    PhoneInput,
    Loader,
    Button
  },
  data () {
    return {
      phone: this.userData.phone,
      name: this.userData.name,
      lastName: this.userData.lastName,
      touchPhoneFlag: '',
      isFormLoading: false,
      errors: {
        city: ''
      }
    }
  },
  props: {
    isReserve: {
      type: Boolean,
      default: false
    },
    isPreOrder: {
      type: Boolean,
      default: false
    },
    isBuyOneClick: {
      type: Boolean,
      default: false
    },
    userData: {
      type: Object,
      validator: obj => {
        return obj.hasOwnProperty('name') && obj.hasOwnProperty('lastName') && obj.hasOwnProperty('phone')
      }
    },
    productId: [String, Number],
    storeId: [String, Number],
    quantity: [String, Number],
    status: [String, Number],
    isFromCart: {
      type: Boolean,
      default: false
    }
  },
  validations: {
    name: {
      required,
      minLength: minLength(2),
      regSpace,
      regNum,
      regSpec,
      regCyr
    },
    lastName: {
      required,
      minLength: minLength(2),
      regSpace,
      regNum,
      regSpec,
      regCyr
    }
  },
  computed: {
    ...mapState({
      isUserAuth: state => state.user.auth,
      selectedUserLocation: state => state.geoLocation.selectedUserLocation
    }),
    ...mapGetters(['urlLanguagePrefix', 'isManager'])
  },
  watch: {
    userData (val) {
      this.phone = val?.phone
      this.name = val?.name
      this.lastName = val?.lastName
    }
  },
  methods: {
    handleSubmit () {
      if (this.checkIsFormValid() && !this.isFormLoading) {
        this.isFormLoading = true

        let formData = {
          'OneClickForm[name]': this.name,
          'OneClickForm[lastName]': this.lastName,
          'OneClickForm[phone]': this.phone,
          'OneClickForm[productId]': this.productId,
          'OneClickForm[isCallback]': 0,
          'OneClickForm[preorder]': 0
        }

        if (this.quantity && !this.isFromCart) {
          formData['OneClickForm[quantity]'] = this.quantity
        }

        if (this.isFromCart) {
          formData['OneClickForm[isFullCartOrder]'] = true
        }

        if (this.isPreOrder) {
          formData['OneClickForm[preorder]'] = 1
        }

        if (this.storeId) {
          formData['OneClickForm[storeId]'] = this.storeId
        }

        if (this.isReserve) {
          formData['OneClickForm[status]'] = this.status
        }

        const analyticsForm = GoogleEnhancedEcommerce.getAnalyticsFormData({
          phone: this.phone,
          externalUserId: this.userData?.user_id || window.config?.user_id || ''
        })
        Object.entries(analyticsForm).forEach(([key, value]) => {
          if (value && typeof value === 'object') {
            formData[`AnalyticsForm[${key}]`] = JSON.stringify(value)
          } else if (value !== null && value !== undefined && value !== '') {
            formData[`AnalyticsForm[${key}]`] = value
          }
        })

        api.order
          .quickOrder(qs.stringify(formData))
          .then(data => {
            if (data) {
              if (data.success) {
                GoogleEnhancedEcommerce.pushUserIdentity({
                  userId: data.user_data?.user_id || this.userData?.user_id || '',
                  phone: this.phone,
                  logged: this.isUserAuth ? 'yes' : 'no',
                  event: 'quick_order_success'
                })
              }
              // Проверяем есть ли параметр у урле для еспутнинка
              const params = (new URL(document.location)).searchParams
              const name = params.get('sc_content') ?? null
              const dataForSend = { ...data }

              if (name) dataForSend.esputnikBlockId = name

              this.$emit('onSubmit', dataForSend)
            }
          })
          // eslint-disable-next-line no-return-assign
          .catch(error => {
            this.$emit('onError', error)
          })
          // eslint-disable-next-line no-return-assign
          .finally(() => (this.isFormLoading = false))
      }
    },
    checkIsFormValid () {
      if (!this.isUserAuth) {
        this.touchPhoneFlag = new Date().getTime().toString()
        return false
      }
      this.$v.$touch()
      if (!this.selectedUserLocation && !this.isReserve) {
        this.errors.city = this.$t('select_user_city_error')
      } else if (this.isReserve) {
        this.errors.city = ''
      }

      return !this.$v.$invalid && !this.errors.city
    }
  }
}
</script>

<style lang="sass" scoped>

.control-box
  margin-bottom: 0
  min-height: 70px

.quick-order-form
  margin: 15px 0 0

.quick-order-form__row
  display: flex
  margin: 0 -5px

.quick-order-form__col
  width: 50%
  padding: 2.5px 5px
  &--full
    width: 100%

+mmax($small)
  .quick-order-form__row
    display: block
  .quick-order-form__col
    width: 100%
    ::v-deep .control-box
      min-height: unset
  .quick-order-form__footer
    margin-top: 40px

.quick-order-form__footer
  display: flex
  align-items: center

.agree-terms__text
  font-size: 12px
  line-height: 15px
  margin-left: 30px
  color: #909090
  max-width: 235px
  +mmax($small)
  margin-left: 15px
  .agree-terms-link
    text-decoration: underline
    color: #909090

.quick-order-modal__btn
  min-width: 120px
  height: 40px
  padding-left: 15px
  padding-right: 15px
</style>
